const strings = {
  errors: {
    required: 'Sorry, this field is required',
    integerRequired: 'This field must be an integer',
    generic: 'Input not valid',
    json: 'Must be valid JSON',
    collectionName: 'Please enter a name for this collection'
  }
};
export default strings;
